// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1mAvx","header":"PatientBlock_header__8wftb","label":"PatientBlock_label__2H_Vj","option":"PatientBlock_option__3tFd9"};